import { useState, useEffect } from "react";
import { BehaviorSubject } from "rxjs";

export const useObservable = (observable: BehaviorSubject<any>) => {
  const [data, setData] = useState({});

  useEffect(() => {
    let subscription;
    if (observable) {
      subscription = observable.subscribe((data) => {
        setData(data);
      });
      return () => {
        subscription.unsubscribe();
      };
    }
  }, [observable]);

  const next = (data: any) => {
    if (observable) {
      observable.next(data);
    }
  };

  return { data: data, next: next };
};

export const createObservable = (defaultValue) => {
  const Subject = new BehaviorSubject(defaultValue);

  return { subject: Subject };
};

export default useObservable;
